export const MainMediaActions = {
    MAIN_MEDIA_CLICKED: 'MainMedia.MAIN_MEDIA_CLICKED',
}
